import * as React from "react";
import { type ReactNode } from 'react';

import styled from 'styled-components';
import { getColor, getFontSize} from '@process-advisor/process-miner/shared/theme';

import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import { apiProvider } from "@process-advisor/process-miner/api/apiProvider";
import { Event } from '@process-advisor/process-miner/api/events'
import { DataGrid } from '@process-advisor/process-miner/analytics/dataGrid'
import { TaskAttributes} from '@process-advisor/process-miner/analytics/task/taskAttributes'
import { TaskHistory} from '@process-advisor/process-miner/analytics/task/taskHistory'
import { EventAttributes} from '@process-advisor/process-miner/analytics/event/eventAttributes'
import { EventHistory} from '@process-advisor/process-miner/analytics/event/eventHistory'

const Wrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100vh;
    background-color: ${getColor('lightestGray')};
    padding-bottom: 10px;
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-column-gap: 25px;
    column-gap: 25px;
    .css-46bh2p-MuiCardContent-root {
        padding-left: 20px;
        padding-right: 2-0px;
    }
`;


export const Analytics: React.FC = () => {
    const [mode, setMode] = React.useState<string>('activity');

    React.useEffect(() => {
        const listener = () => {
            //updateContent()
        };
        listener();

        apiProvider.on(Event.setActionBar_Analytics, listener);

        return () => {
            apiProvider.off(Event.setActionBar_Analytics, listener);
        };
    }, []);


    const onChange = (key: string) => {
        if (key === '1') setMode('activity')
        if (key === '2') setMode('step')
      };
      
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: apiProvider.getEntityUpper() + 's',
            children: <TaskAttributes/>,
        },
        {
            key: '2',
            label: apiProvider.getEntityUpper() + ' History',
            children: <TaskHistory/>,
        },
        {
            key: '3',
            label: 'Events',
            children: <EventAttributes/>,
        },
        {
            key: '4',
            label: 'Event History',
            children: <EventHistory/>,
        },
      ];

    return (
        <div>
        <Wrapper>   
            <Card  >
                <CardContent>
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
                </CardContent>
            </Card>
        </Wrapper>
        </div>
    );
};

/*
                    <Tabs id="custom-tabs">
	    		        <TabList>
		             	    <Tab>Activities</Tab>
	    			        <Tab>Steps</Tab>
		        	        <Tab>Issues</Tab>
			    	        <Tab>Events</Tab>
    		    	    </TabList>
                        <TabPanel>
                            <DataGrid mode='activity'/>
                        </TabPanel>
                        <TabPanel>
                            <DataGrid mode='step'/>
                        </TabPanel>
                    </Tabs>

*/